module.exports = __webpack_public_path__ + "static/media/219-Milo-Platz_ID_1m.8fc7b145.mp3";